import { buildMock } from 'utils'

import serverResponse from '../serverResponse'

export default buildMock(serverResponse())
